import React, { useState, useEffect } from "react";
import axios from "axios";

const ReferralCodeForm = () => {
  const [referralCode, setReferralCode] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/referral-code`)
      .then(({ data }) => {
        setReferralCode(data.referral_code || "");
        setLoading(false);
      })
      .catch(() => {
        setStatus("Failed to load referral code");
        setLoading(false);
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/referral-code`, {
        referral_code: referralCode,
      });
      setStatus("Referral code saved successfully!");
    } catch {
      setStatus("Failed to save referral code.");
    }
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <div className="container">
      <h3>General Settings</h3>
      {status && <div className="alert alert-info">{status}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Referral Code</label>
          <input
            type="text"
            name="referral_code"
            value={referralCode}
            onChange={(e) => setReferralCode(e.target.value)}
            className="form-control"
            placeholder="Enter referral code"
          />
        </div>

        <button className="btn btn-primary" type="submit">
          Save
        </button>
      </form>
    </div>
  );
};

export default ReferralCodeForm;
